'use client';

import { useState } from 'react';
import { AppSidebar } from '@/components/app-sidebar';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { useAuth } from '@/contexts/AuthContext';
import { PublicSessionProvider } from '@/contexts/PublicSessionContext';
import { AuthFlow } from '@/components/auth/auth-flow';
import Script from 'next/script';
import { ReferralBanner } from '@/components/referral-banner';
import { ChatOutline } from '@/components/chat-outline/ChatOutline';


export default function Layout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useAuth();
  const [isCollapsed] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    const saved = localStorage.getItem('sidebar:state');
    return saved !== 'true';
  });

  return (
    <PublicSessionProvider>
      <AuthFlow>
        <Script
          src="https://cdn.jsdelivr.net/pyodide/v0.23.4/full/pyodide.js"
          strategy="afterInteractive"
        />
        <div className="flex flex-col h-dvh">
          <ReferralBanner />
          <SidebarProvider defaultOpen={!isCollapsed} className="flex-1 min-h-0">
            {user && <AppSidebar/>}
            {user && <ChatOutline />}
            <SidebarInset>{children}</SidebarInset>
          </SidebarProvider>
        </div>
      </AuthFlow>
    </PublicSessionProvider>
  );
}
